var map = {
	"./promo_00.jpg": 54,
	"./promo_01.jpg": 5047,
	"./promo_02.jpg": 5048,
	"./promo_03.jpg": 5049,
	"./promo_04.jpg": 53,
	"./promo_05.jpg": 5050
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5046;